import React from 'react';
import './style.css';
import { useNavigate } from 'react-router-dom';
import { IoChevronForwardOutline } from 'react-icons/io5';
import { BsArrowRightShort } from 'react-icons/bs';

import heroSection_four from '../../../Assets/resource/CPOBanner.png';



export default function Banners() {
    const navigate = useNavigate();
    return (
        <section className="banner flex bg-light-gradient pb-0 md:pb-28 lg:pb-40 pt-20 md:pt-28 lg:pt-40 my-10 xl:my-0">
            <div className="z-10 containers-min mx-auto sm:flex  md:flex-row flex-col sm:items-center ">
                <div className="md:w-6/12 h-fit flex justify-center items-start flex-col min-w-[300px] ">
                    <h1 className="leading-tight !h3 font-gilroylight font-light">
                        Grow your
                        <span className="font-gilroy font-bold"> Business </span>
                        with the best
                        <span className="font-gilroy font-bold pl-3">
                        Charging Experience
                        </span>
                    </h1>
                    <h5 className="lg:mt-6 mt-4 font-poppins">
                        Deploy a wide range of enterprise-grade chargers to meet every customer need-residential, commercial, or fleet
                    </h5>
                    <h5 className="sm:mt-4 lg:mt-6 mt-5 lg:leading-9 leading-normal font-medium font-poppins">
                        Integrate with our intuitive CMS or any system of your choice. With future-ready hardware, smart software, and excellent support, expanding your charging network has never been easier
                    </h5>
                    <div
                        className='mt-5'
                        onClick={() => {
                            navigate('/get-in-touch')
                        }}
                    >
                        <button
                            className='btn-new font-semibold relative flex justify-center items-center rounded-full pl-16 pr-6 font-poppins'
                        >
                            <span className="flex justify-center items-center">
                                <IoChevronForwardOutline className="h-[22px] w-[25px] ioArrow" />
                                <BsArrowRightShort className="h-[30px] w-[30px] tailArrow" />
                            </span>
                            Talk to an expert
                        </button>
                    </div>
                </div>

                <div className="md:w-5/12 w-full p-4 md:mt-0 mt-10 mx-auto relative lg:min-h-[400px] min-h-[300px]">
                    <div className="absolute top-20 left-auto -bottom-20 -right-20 bg-gradient w-32 md:w-56 lg:w-80 hidden md:block"></div>
                    <img
                        loading="lazy"
                        className="h-full w-full rounded-lg z-10 relative"
                        src={heroSection_four}
                        alt="Switch to EV"
                    />
                </div>
            </div>
        </section>
    );
}
